import React from 'react';
import { ImageUplaod } from '../../components/images-to-pdf/ImageUpload';

export const ImageToPdfNew: React.FC = () => {
	return (
		<ImageUplaod
			otherProps={{
				accept: 'image/*',
				multiple: true
			}}
			label='Upload images'
		/>
	);
};
